import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMainNewsLoading, EGetMainNewsActionType } from './types';

export const getMainNewsLoading: () => TGetMainNewsLoading = actionGenerator<EGetMainNewsActionType.Loading>(
  EGetMainNewsActionType.Loading,
);
